import React from "react";

const Community = () => {
  return (
    <a href="https://open.kakao.com/o/ggCZxO2b">
      <div
        style={{ textAlign: "center", display: "flex", alignItems: "center" }}
      >
        카카오톡 공부방
      </div>
    </a>
  );
};
export default Community;
